<script lang="ts">
  import DiscoveryPanel from "@shared/svelte/DiscoveryPanel/DiscoveryPanel.svelte";
  import ProductLineFilters from "@retailer/svelte/ProductLines/ProductLineContainer/ProductLineFilters.svelte";
  import ProductListingResults from "@retailer/svelte/ProductLines/ProductLineContainer/ProductListingResults.svelte";

  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import { ProductLineListingStore } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";
  import { getControlStateAuthenticationService } from "@retailer/services/retailer_user_authentications_service";
  import RetailerUserAuthenticationsStore from "@retailer/svelte/stores/RetailerUserAuthenticationsStore";

  export let mobileMode: boolean;
  export let stateParams;
  export let Cart: any = null;
  export let productIndexBannersRes = [];
  export let shoppableUnitRes = {};
  export let discoveryPanelRes: any = {};
  export let includeExternalAds: boolean = false;
  export let dedupeOrganicResultsFromAds: boolean = true;
  export let overrideStateParams: any = null;
  export let overridePath: string = "";

  const discoveryPanelConfig = discoveryPanelRes?.data || [];

  let authService = getControlStateAuthenticationService();

  let plpAuthState: string;
  let isSpiritPlp: boolean = false;
  let retailerAuthApplicable: boolean = false;
  let isDistributorPlp: boolean = false;

  $: plpAuthState = authService?.getRetailerUserAuthenticationStatus?.(
    $RetailerUserAuthenticationsStore,
  );

  $: isSpiritPlp = $ProductLineListingStore?.productLines?.some(
    pl => pl.product_type_name == "Spirits",
  );
  $: retailerAuthApplicable = plpAuthState && isSpiritPlp;
  $: isDistributorPlp = stateParams.distributors?.length > 0;

  let innerWidth: number | null;
</script>

<svelte:window bind:innerWidth />

<div class="fizz-styles">
  <div class="product-listing-container">
    {#if retailerAuthApplicable && plpAuthState == "pending" && !isDistributorPlp}
      <div
        class:fizz-inset-horizontal-16={!innerWidth || innerWidth >= 1024}
        style="padding-right: 0;"
      >
        {#if !innerWidth || innerWidth >= 700}
          <svelte:component
            this={authService?.bannerComponent}
            authStatus={plpAuthState}
            {authService}
          />
        {:else if innerWidth < 700}
          <div
            class="fizz-radius-large fizz-inset-square-32 fizz-stack-16"
            style="background-color: rgb(238, 248, 246)"
          >
            <svelte:component
              this={authService?.ctaComponent}
              authStatus={plpAuthState}
              {authService}
            />
          </div>
        {/if}
      </div>
    {:else if retailerAuthApplicable && plpAuthState == "invalid"}
      <div class="fizz-inset-horizontal-16" style="padding-right: 0">
        <div class="fizz-stack-24" data-testid="retailer-user-auth-invalid-plp">
          {#if $LayoutStore.isDesktop && authService?.bannerComponent}
            <svelte:component this={authService?.bannerComponent} authStatus="invalid" {authService} />
          {:else if authService?.ctaComponent}
            <svelte:component this={authService?.bannerComponent} authStatus="invalid" {authService} />
          {/if}
        </div>
      </div>
    {/if}
    <div
      class:fizz-layout-sidebar-main={mobileMode === false}
      style={!mobileMode && `--sidebar-max-width: minmax(230px, 304px)`}
    >
      <div data-grid-area="sidebar">
        <ProductLineFilters
          {mobileMode}
          {overridePath}
          {overrideStateParams}
          showIfNoResults={false}
        />
      </div>
      <div data-grid-area={"main"}>
        <DiscoveryPanel
          configuration={discoveryPanelConfig}
          pageName={discoveryPanelRes.pageName}
          pageValue={discoveryPanelRes.pageValue}
          {mobileMode}
        />

        <ProductListingResults
          bind:productIndexBannersRes
          bind:shoppableUnitRes
          {mobileMode}
          {stateParams}
          {Cart}
          {includeExternalAds}
          {dedupeOrganicResultsFromAds}
          {overrideStateParams}
          {overridePath}
        />
      </div>
    </div>
  </div>
</div>
